import { useEffect, useState } from "react";
import {
  currentThemeChoice,
  parseThemeChoice,
  THEME_CHANGED_EVENT,
  type ThemeChoice,
} from "@/lib/theme";

export function useThemeChoice(): ThemeChoice {
  const [theme, setTheme] = useState<ThemeChoice>(currentThemeChoice);

  useEffect(() => {
    const root = document.documentElement;
    const syncFromDocument = () => setTheme(currentThemeChoice());
    const onThemeChanged = (event: Event) => {
      const next = parseThemeChoice(
        (event as CustomEvent<{ theme?: unknown }>).detail?.theme,
      );
      setTheme(next ?? currentThemeChoice());
    };

    window.addEventListener(THEME_CHANGED_EVENT, onThemeChanged);
    const observer = new MutationObserver(syncFromDocument);
    observer.observe(root, {
      attributeFilter: ["class", "data-theme-choice"],
      attributes: true,
    });

    return () => {
      window.removeEventListener(THEME_CHANGED_EVENT, onThemeChanged);
      observer.disconnect();
    };
  }, []);

  return theme;
}
